import { render, staticRenderFns } from "./shipment-items-table.vue?vue&type=template&id=545470ab&scoped=true"
import script from "./shipment-items-table.vue?vue&type=script&lang=js"
export * from "./shipment-items-table.vue?vue&type=script&lang=js"
import style0 from "./shipment-items-table.vue?vue&type=style&index=0&id=545470ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545470ab",
  null
  
)

export default component.exports